<template>
  <f7-page name="error">
    <f7-navbar id="navbar" :title="$t('error')" color="black">
      <f7-nav-right>
        <f7-icon f7="exclamationmark_triangle" color="red"></f7-icon>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small>{{ $t('copyright') }}</small>
    </f7-toolbar>

    <f7-toolbar bottom>
      <small>{{$t('copyright')}}</small>
    </f7-toolbar>

    <f7-block-title>{{ $t('error-oops') }}</f7-block-title>
    <f7-block strong>
      <p>
      {{ $t('error-engineers') }}
      </p>
      <p>
      Token sesiune {{ token }}
      </p>
    </f7-block>

    <f7-list>
      <f7-list-item :title="$t('error-retry')" link="/"></f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
  import { BugImage } from '../icons-svg/icons-svg.js';

  export default {
    props: {
      status: Number,
      message: String,
      custom_message: String,
    },
    data() {
      return {
        token: null,
      }
    },
    mounted() {
      const self = this;
      self.token = localStorage.token;
    }
  }

</script>
